module.exports = __webpack_public_path__ + "static/media/Arial_Rounded_MT_Bold.bf1af12f.svg";